var collectionGalleryList = $("#bt32-csb_pswpContainer").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: "#bt32-csb_mainImage",
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    speed: 500,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                vertical: false,
                verticalSwiping: false,
            },
        },
    ],
});

var collectionGallery = $("#bt32-csb_mainImage").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: "#bt32-csb_pswpContainer",
    speed: 500,
});

var dynamicGallery = lightGallery(document.body, {
    licenseKey: "DA7E83CA-6E474542-97592C9F-8A8DFF9D",
    dynamic: true,
    controls: false,
    download: false,
    plugins: [lgZoom],
    dynamicEl: [],
});

/* ---  product functions --- */
var productInter = {
    addToCart: function (target) {
        if (target.disabled) return false;
        var chairData = new FormData(document.querySelector('form[action="/cart/add"]'));
        // create main item data
        var itemsData = {
            items: [
                {
                    id: chairData.get("id"),
                    quantity: chairData.get("quantity"),
                },
            ],
        };

        $.ajax({
            type: "POST",
            dataType: "JSON",
            url: "/cart/add.js",
            data: itemsData,
            timeout: 8000,
            success: function () {
                $.ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "JSON",
                    timeout: 8000,
                })
                    .done(function (cartData) {
                        ajaxcart.updateCartItem(cartData);
                        ajaxcart.openCart();
                    })
                    .fail(function () {
                        ajaxcart.openCart();
                    })
                    .always(function () {
                        target.classList.remove("bt20-csb_addingItem");
                        target.disabled = false;
                    });
                // rdt('track', 'AddToCart');
            },
            error: function (err) {
                target.classList.remove("bt20-csb_addingItem");
                target.disabled = false;
                var isNetworkGuardError = err && (err.status == 403 || err.status == 429 || err.statusText == "timeout");
                alert(isNetworkGuardError ? "アクセスが集中しています。時間をおいて再度お試しください。" : err?.responseJSON?.description || err?.responseJSON?.message || "カートへの追加に失敗しました。時間をおいて再度お試しください。");
            },
            beforeSend: function () {
                target.classList.add("bt20-csb_addingItem");
                target.disabled = true;
            },
        });
        //       	var cuurent_option = document.querySelector('input[value="'+ chairData.get('id') +'"]');
        // Google Ads tag
        //       	gtag('event','add_to_cart', {
        //     		'send_to': 'AW-721545460',
        //             'value': parseInt(cuurent_option.dataset.price) / 100,
        //             'items': [
        //                 {
        //                   'id': cuurent_option.dataset.id,
        //                   'google_business_vertical': 'retail'
        //                 }
        //             ]
        //         });
    },
    changeToThisOption: function (current_variant, stopPopstate) {
        var cart = document.querySelector(".bt20-csb_cart"),
            notifymeContainer = document.querySelector(".bt32-notifymeContainer"),
            cartBtn = document.getElementById("bt20-csb_cartBtn"),
            inventory = document.querySelector(".bt20-csb_inventory");

        //update product gallery and gallery list
        var slickNumbers = collectionGallery.slick("getSlick").slideCount;
        for (var i = 0; i < slickNumbers; i++) {
            collectionGallery.slick("slickRemove", 0);
            collectionGalleryList.slick("slickRemove", 0);
        }
        var this_option_images = document.querySelectorAll(".image_storage_" + current_variant.id);
        for (var i = 0; i < this_option_images.length; i++) {
            var resizeImage = Boulies.imageResize(this_option_images[i].value, 900, "heightOnly");
            collectionGallery.slick("slickAdd", '<a class="pswp_image" href="' + this_option_images[i].value + '" data-lg-size="600-900" target="_blank"><img class="bt32-collectionGalleryItem" src="' + resizeImage + '"></a>');
            collectionGalleryList.slick("slickAdd", '<div><img src="' + resizeImage + '"></div>');
        }

        // update url history
        if (!stopPopstate) {
            var current_search = Boulies.getUrlkey() ? Boulies.getUrlkey() : {},
                _search = "?";
            current_search["variant"] = current_variant.value;
            for (var i in current_search) {
                _search += i + "=" + current_search[i] + "&";
            }
            history.pushState({}, "", _search.substr(0, _search.length - 1));
        }

        // update price
        document.getElementById("bt20-collection_price").innerHTML = Boulies.formatPrice(parseInt(current_variant.dataset.price));
        document.getElementById("Klarna_notify").dataset.purchaseAmount = parseInt(current_variant.dataset.price);
        if (window.Klarna.OnsiteMessaging) {
            window.Klarna.OnsiteMessaging.refresh();
        }

        // update button
        if (current_variant.dataset.available == "true") {
            cart.style.display = "block";
            notifymeContainer.style.display = "none";
            cartBtn.classList.add("bt20-csb_activeCartBtn");
            cartBtn.disabled = false;
            inventory.classList.remove("bt20-csb_outOfStock");
            inventory.classList.add("bt20-csb_inStock");
        } else {
            var notyfymeData = document.getElementById("bt32-notifyme_data");
            inventory.classList.remove("bt20-csb_inStock");
            inventory.classList.add("bt20-csb_outOfStock");
            cart.style.display = "none";
            notyfymeData.dataset.region = Boulies.setting.region;
            notyfymeData.dataset.itemName = current_variant.dataset.productSeries;
            notyfymeData.dataset.itemColor = current_variant.dataset.options;
            notyfymeData.dataset.itemSku = current_variant.id;
            notifymeContainer.style.display = "block";
        }

        // Dynamic remarketing events and parameters
        //           gtag('event','view_item', {
        //               'send_to': 'AW-721545460',
        //               'value': parseInt(current_variant.dataset.price) / 100,
        //               'items': [
        //                   {
        //                     'id': current_variant.dataset.sku,
        //                     'google_business_vertical': 'retail'
        //                   }
        //               ]
        //           })
    },
    interval_counting: undefined,
    notifyMe: function (target) {
        if (target.classList.contains("disabled")) return;
        var notifymeData = document.getElementById("bt32-notifyme_data");
        if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(notifymeData.value)) {
            alert("有効なメールアドレスを入力してください。");
            return;
        }
        var requestData = JSON.parse(JSON.stringify(notifymeData.dataset));
        requestData["email"] = notifymeData.value;
        $.ajax({
            type: "POST",
            url: "https://app.boulies.com/notifyorders/notifyme",
            data: requestData,
            beforeSend: function () {
                target.classList.add("disabled");
                target.innerHTML = "送信中...";
            },
            error: function (xhr, status, error) {
                alert("通知リクエストの送信に失敗しました。時間をおいて再度お試しください。");
                target.classList.remove("disabled");
                target.innerHTML = "登録";
            },
            success: function () {
                target.innerHTML = "リクエストを受け付けました。";
            },
        });
    },
    init: function () {
        document.getElementById("bt20-csb_cartBtn").addEventListener("click", function (e) {
            e.preventDefault();
            productInter.addToCart(this);
        });

        document.getElementById("bt32-notifymeBtn").addEventListener("click", function (e) {
            e.preventDefault();
            productInter.notifyMe(this);
        });

        var options = document.getElementById("bt20-addToCartForm").querySelectorAll('input[name="id"]');
        options.forEach(function (option) {
            option.addEventListener("change", function () {
                productInter.changeToThisOption(this);
            });
        });

        window.addEventListener("popstate", (event) => {
            var url_param = Boulies.getUrlkey();
            if (!url_param || !url_param.variant) return false;
            var selected_variant = document.querySelector('input[value="' + url_param.variant + '"]');
            selected_variant.checked = true;
            productInter.changeToThisOption(selected_variant, true);
        });

        productInter.changeToThisOption(document.querySelector('input[type="radio"]:checked'), true);
    },
};

// ==============================================================
// Run Code After Document Ready
// ==============================================================
$(document).ready(function () {
    productInter.init();

    // show stock location for united kingdom only
    // if($.cookie('bouliesGeo_location') == 'GB') document.getElementById('bt40-csb_stockLocation').style.display = 'block';

    $(".bt20-csb_mainImage").on("click", ".pswp_image", function (e) {
        e.preventDefault();
        dynamicGallery.refresh([{ src: this.href }]);
        dynamicGallery.openGallery();
    });
});
